module.exports = __webpack_public_path__ + "static/media/logo.e70dafe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 18
// module chunks = 0